module.exports = __webpack_public_path__ + "static/spring-break-dd0d24498c37ea26416da526ccc57a46.svg";